import { BaseLayout } from 'components/common';
import SeoHead from 'components/common/SeoHead';
import JsonLd from 'components/common/JsonLd';
import QuestionAnswers from 'components/faqs/QuestionAnswers';
import { questionAndAnswers } from 'constants/faq-questions';

const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, '') ||
  'https://vitaleducators.com';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: (Object.values(questionAndAnswers) as { question: string; answer: string }[][]).flat().map(
    ({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })
  ),
};

const productSchema = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'Vital Educators Premium Plan',
  description:
    'Premium tutor subscription — profile insights, higher search ranking, and a Premium badge on your profile to stand out to more students.',
  brand: {
    '@id': `${SITE_URL}/#organization`,
  },
  offers: {
    '@type': 'Offer',
    priceCurrency: 'GBP',
    price: '39.99',
    priceSpecification: {
      '@type': 'UnitPriceSpecification',
      price: '39.99',
      priceCurrency: 'GBP',
      referenceQuantity: {
        '@type': 'QuantitativeValue',
        value: '1',
        unitCode: 'MON',
      },
    },
    availability: 'https://schema.org/InStock',
    url: `${SITE_URL}/faqs`,
  },
  audience: {
    '@type': 'Audience',
    audienceType: 'Private tutors',
  },
};

const FAQs = () => {
  return (
    <>
      <SeoHead
        title="FAQs | Vital Educators"
        description="Answers to common questions about finding tutors, booking sessions, and using Vital Educators."
        path="/faqs"
      />
      <JsonLd schema={faqSchema as Record<string, unknown>} />
      <JsonLd schema={productSchema as Record<string, unknown>} />
      <BaseLayout>
        <QuestionAnswers />
      </BaseLayout>
    </>
  );
};

export default FAQs;

